<template>
  <div class="form-input">
    <v-radio-group :name="item.name" variant="outlined" :modelValue="modelValue" @input="updateValue">
      <template #label>
        <span>{{ item.label }}<strong class="text-red" v-if="item.isRequired"> *</strong></span>
      </template>
      <v-radio v-for="(option, index) in item.content" :key="index" :label="option.text" :value="option.text"></v-radio>
    </v-radio-group>

  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
const props = defineProps({
  item: Object,
  modelValue: [String, Number, Boolean, Array, Object]
});

const emit = defineEmits(['update:modelValue']);

const updateValue = (event) => {
  emit('update:modelValue', event.target.value);
};
</script>